import z from "zod";
import { Contractor } from "@/api/williams/contractors";
import { RegionSchema } from "@/api/williams/region";
import { UserSchema } from "../users";

const REQUIRED_FIELD_ERROR = "Required Field";

export const ContractorSchema = z
  .object({
    id: z.string(),
    name: z.string().trim().nonempty(REQUIRED_FIELD_ERROR),
    addressLine1: z.string().nullish(),
    addressLine2: z.string().nullish(),
    addressLine3: z.string().nullish(),
    country: z.string().nullish(),
    postalCode: z.string().nullish(),
    shopOrField: z.string().nullish(),
    weldingSpecialist: UserSchema.nullish(),
    regions: z.array(RegionSchema).nullish(),
  })
  .transform((data) => data as Contractor);
